import { memo } from "react";
import { OpportunitySizeOption } from "../growth/utils";
import NodeColorLegend from "./NodeColorLegend";
import { text, surface, status, fontWeight, spacing, borderRadius, fontSizeValues } from "@atlas-int/tokens";

const ChartLegend = ({ rScale: _rScale, sizing }: { rScale?: unknown; sizing?: string }) => {

  const getSizingLegendText = () => {
    switch (sizing) {
      case OpportunitySizeOption.CountryTrade:
        return " based on Country Exports";
      case OpportunitySizeOption.WorldTrade:
        return " based on Global Exports";
      default:
        return "";
    }
  };

  return (
    <div
      data-download-exclude
      style={{
        position: "absolute",
        right: 4,
        top: 100,
        background: "rgba(255,255,255,.85)",
        borderRadius: borderRadius.base,
        padding: `${spacing[4]} ${spacing[6]}`,
        maxWidth: 150,
        zIndex: 1,
      }}
    >
      <div>
        <div
          style={{
            fontWeight: fontWeight.bold,
            fontSize: fontSizeValues.xs,
            marginBottom: spacing[6],
            color: status.gold,
          }}
        >
          How to Read
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: spacing[6],
          }}
        >
          <svg width={126} height={95}>
            <text x="63" y="75" textAnchor="middle" fontSize="11" fill={text.primary}>
              Distinct
            </text>
            <text x="63" y="87" textAnchor="middle" fontSize="11" fill={text.primary}>
              Products
            </text>
            <g transform="translate(13, 0)">
              <circle
                cx="10"
                cy="40"
                r="7"
                fill={surface.muted}
                stroke={text.primary}
                strokeWidth="1"
              />
              <circle
                cx="30"
                cy="40"
                r="7"
                fill={surface.muted}
                stroke={text.primary}
                strokeWidth="1"
              />
              <circle
                cx="90"
                cy="40"
                r="7"
                fill={surface.muted}
                stroke={text.primary}
                strokeWidth="1"
              />
              <path
                d="M 10,31 Q 20,25 30,31"
                fill="none"
                stroke={text.primary}
                strokeWidth="1"
                markerStart="url(#arrowhead-start)"
                markerEnd="url(#arrowhead)"
              />
              <text
                x="20"
                y="10"
                textAnchor="middle"
                fontSize="11"
                fill={text.primary}
              >
                Similar
              </text>
              <text
                x="20"
                y="22"
                textAnchor="middle"
                fontSize="11"
                fill={text.primary}
              >
                Products
              </text>
              <path
                d="M 10,49 Q 50,75 90,49"
                fill="none"
                stroke={text.primary}
                strokeWidth="1"
                markerStart="url(#arrowhead-start)"
                markerEnd="url(#arrowhead)"
              />
            </g>
            <defs>
              <marker
                id="arrowhead"
                markerWidth="5"
                markerHeight="4"
                refX="4"
                refY="2"
                orient="auto"
              >
                <polygon points="0 0, 5 2, 0 4" fill={text.primary} />
              </marker>
              <marker
                id="arrowhead-start"
                markerWidth="5"
                markerHeight="4"
                refX="1"
                refY="2"
                orient="auto"
              >
                <polygon points="5 0, 5 4, 0 2" fill={text.primary} />
              </marker>
            </defs>
          </svg>
        </div>
        <div
          style={{
            fontSize: fontSizeValues.xs,
            color: text.primary,
            marginBottom: spacing[6],
          }}
        >
          Products that are <strong>closer</strong> to each other require{" "}
          <strong>similar capabilities</strong>
        </div>
        <div
          style={{
            fontSize: fontSizeValues.xs,
            color: text.primary,
            marginBottom: spacing[8],
          }}
        >
          Products that are <strong>distant</strong> require{" "}
          <strong>distinct capabilities</strong>
        </div>
      </div>
      <NodeColorLegend />
      {sizing !== OpportunitySizeOption.None && (
        <div>
          <div
            style={{
              fontSize: fontSizeValues.xs,
              marginTop: spacing[8],
              marginBottom: spacing[4],
            }}
          >
            <span style={{ fontWeight: "bold" }}>Node Sizing </span>{" "}
            {getSizingLegendText()}
          </div>
        </div>
      )}
    </div>
  );
};
export default memo(ChartLegend);
